import {Box, Image, Text} from '@chakra-ui/react'
import {Fragment, useEffect, useRef, useState} from 'react'
import {getCharColorByScore, getIconByChar} from './utilsExamResult'
import {useSelector} from 'react-redux'

const Word = ({
  word,
  currentSelectWord,
  setIsOpenPopover,
  handleClickWord,
}: {
  word: any
  currentSelectWord: any
  setIsOpenPopover: any
  handleClickWord: any
}) => {
  const {audioTime, isOpenBadPause, isPauseAudio} = useSelector(
    (state: any) => state.examResult,
  )
  const [isScrolling, setIsScrolling] = useState(false)
  const wordRef = useRef<any>(null)

  useEffect(() => {
    if (
      audioTime.currentWordTime >= word?.start_time?.toFixed(5) &&
      audioTime.currentWordTime <= word?.end_time?.toFixed(5) &&
      wordRef.current
    ) {
      setIsScrolling(true)
      if (isScrolling) {
        return
      }
      const parent = document.querySelector(
        '.exam-result-scroll-tab',
      ) as HTMLElement
      const childRect = wordRef.current.getBoundingClientRect()
      const parentRect = parent.getBoundingClientRect()
      if (childRect.bottom > parentRect.bottom - 100) {
        parent.scrollTop =
          parent.scrollTop + (childRect.bottom - parentRect.bottom) + +100
      }

      if (childRect.top < parentRect.top + 100) {
        parent.scrollTop =
          parent.scrollTop - (parentRect.top - childRect.top) - 100
      }
      setTimeout(() => {
        setIsScrolling(false)
      }, 2000)
    }
  }, [audioTime.currentWordTime])

  const getIsShowStatusPhrase = (char: any) => {
    return Boolean(char === '~' || char === '•')
  }

  const getBackgroundColor = () => {
    if (word?.phonemes?.find((item: any) => item?.score < 50)) {
      return '#fadedd'
    }
    if (word?.phonemes?.find((item: any) => item?.score < 75)) {
      return '#fff5cc'
    }
    return '#d1e9ff'
  }

  return (
    <Box
      ref={wordRef}
      position={'relative'}
      cursor={'pointer'}
      fontSize={{base: '20px', md: '28px'}}
      fontWeight={600}
      px={'4px'}
      bg={
        isPauseAudio &&
        audioTime.currentWordTime >= currentSelectWord?.start_time &&
        audioTime.currentWordTime <= currentSelectWord?.end_time
          ? currentSelectWord?.start_time === word?.start_time &&
            currentSelectWord?.word === word?.word
            ? getBackgroundColor()
            : 'unset'
          : audioTime.currentWordTime >= word?.start_time &&
              audioTime.currentWordTime <= word?.end_time &&
              !isOpenBadPause
            ? getBackgroundColor()
            : 'unset'
      }
      borderRadius={'8px'}
      onClick={() => {
        setIsOpenPopover(true)
        handleClickWord(word)
      }}>
      {word?.letters ? (
        word?.letters?.map((char: any, indexChar: any) => {
          return (
            <Fragment key={indexChar}>
              <Text
                as={'span'}
                flexWrap={'nowrap'}
                color={getCharColorByScore(char.score)}>
                {char.letter}
              </Text>
              {getIsShowStatusPhrase(char.letter) && (
                <Image
                  className="status-phrase"
                  opacity={
                    audioTime.currentWordTime >= word?.start_time &&
                    audioTime.currentWordTime <= word?.end_time
                      ? 1
                      : 0
                  }
                  src={getIconByChar(char.letter)}
                  position={'absolute'}
                  zIndex={1}
                  top={
                    audioTime.currentWordTime >= word?.start_time &&
                    audioTime.currentWordTime <= word?.end_time
                      ? '-40px'
                      : '10px'
                  }
                  left={0}
                  transition={'top 1s, opacity 0.2s'}
                  userSelect={'none'}
                />
              )}
            </Fragment>
          )
        })
      ) : (
        <Text>{word?.text}</Text>
      )}
    </Box>
  )
}

export default Word
